module.exports = __webpack_public_path__ + "static/WEDDING E&M-132-860c36f9d0913965db40c8bd648f145f.jpg";